import { Stack, Text } from '@mantine/core';
import { translate } from '@shared/i18n/translate.tsx';
import { useState, useRef, useEffect } from 'react';

interface ExpandableTextProps {
  text?: string | null;
  maxLines?: number;
  expandable?: boolean;
  showToggleButton?: boolean;
  emptyPlaceholder?: string;
  style?: { fontSize: string };
}

export const ExpandableText = ({
  text,
  maxLines = 5,
  expandable = true,
  showToggleButton = true,
  emptyPlaceholder = '—',
  style
}: ExpandableTextProps) => {
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseInt(
        getComputedStyle(textRef.current).lineHeight || '16',
        10
      );
      const maxHeight = lineHeight * maxLines;
      setShowButton(textRef.current.scrollHeight > maxHeight);
    }
  }, [text, maxLines]);

  if (!text) return <Text c='dimmed'>{emptyPlaceholder}</Text>;

  return (
    <Stack gap={4}>
      <Text
        ref={textRef}
        lineClamp={expanded || !expandable ? undefined : maxLines}
        style={{
          cursor: expandable ? 'pointer' : 'default',
          ...style
        }}
        onClick={() => {
          if (expandable && !showToggleButton) setExpanded(!expanded);
        }}
      >
        {text}
      </Text>

      {showButton && showToggleButton && (
        <Text
          c='blue'
          style={{
            cursor: 'pointer',
            fontSize: '13px',
            userSelect: 'none',
            fontWeight: '500',
            fontStyle: 'italic'
          }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded
            ? translate('commons.hide')
            : translate('commons.show_full')}
        </Text>
      )}
    </Stack>
  );
};
